
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M51.415 27.755h-.665V14.42c0-2.065-1.68-3.78-3.78-3.78h-.245a3.787 3.787 0 00-3.78 3.78v13.335H27.02v-13.37c0-2.065-1.68-3.78-3.78-3.78h-.245a3.787 3.787 0 00-3.78 3.78V27.72h-.665a3.197 3.197 0 00-3.185 3.185V43.75c0 5.845 4.76 10.57 10.57 10.57h2.59v4.305c0 .42.35.735.735.735h11.305a.74.74 0 00.735-.735V54.32h2.59c5.845 0 10.57-4.76 10.57-10.57V30.905c.105-1.75-1.295-3.15-3.045-3.15zm-19.67 11.97l4.34-5.145c.21-.28.63-.35.91-.175.315.175.455.525.385.875l-1.085 3.78 1.575.455c.245.07.455.28.525.49.07.245 0 .525-.14.7l-4.865 5.67c-.14.175-.35.245-.56.245a.798.798 0 01-.385-.105c-.315-.175-.455-.56-.315-.91l1.54-4.27-1.54-.42a.726.726 0 01-.525-.525.685.685 0 01.14-.665zM39.9 58.17h-9.8v-3.535h9.8v3.535z","fill":"#27AE60"}})])
          )
        }
      }
    